var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.918985 9.99949H6.91435C8.61848 9.99949 10 8.52916 10 6.71547V0.406102C10 0.182134 9.82887 0 9.61843 0H8.8481C8.63718 0 8.46652 0.182134 8.46652 0.406102V6.23489C8.46652 7.41238 7.56964 8.36692 6.46327 8.36692H2.61784C2.44959 8.36692 2.35659 8.15979 2.46157 8.02051L3.84069 6.18591C3.97299 6.0099 3.94615 5.75277 3.78077 5.61196L3.18205 5.10229C3.01667 4.96148 2.77555 4.99005 2.64277 5.16606L0.202821 8.41233C-0.277979 9.05209 0.150091 10 0.919945 10L0.918985 9.99949Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterIcon);
export default __webpack_public_path__ + "static/media/EnterIcon.0b8c43ce926b8be7c956d28d6ba6e271.svg";
export { ForwardRef as ReactComponent };